/**
 * Creating our app store.
 * @module src/store
 */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { legacy_createStore as createStore } from 'redux';
import { createTransform, persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import reducer from './ducks';

// NOTE: `whiteList` below is not a redux-persist option (the real key is
// `whitelist`), so it is silently ignored and every reducer key is persisted.
// Do not "fix" that spelling: eleven other ducks rely on this de-facto
// persist-everything behavior today. The submission duck must never persist
// (its pollGeneration counter is only meaningful in memory for the lifetime
// of the tab, and a stale value read back after reload would freeze polling
// until logout), so it is excluded explicitly via a transform instead.
//
// The two directions are not symmetric. Inbound (state -> storage) returns
// undefined so nothing is ever written. Outbound (storage -> state, on
// rehydrate) must NOT also return undefined: on the very first load after a
// deploy there is no persisted `submission` key at all, so REHYDRATE would set
// state.submission to undefined outright rather than leaving the reducer's own
// initialState in place, and the first render that reads
// state.submission.byCaseExternalId crashes white. Returning the same shape as
// the reducer's initialState keeps rehydrate a no-op for this slice instead.
export const excludeSubmissionState = createTransform(
  () => undefined,
  () => ({ byCaseExternalId: {} }),
  { whitelist: ['submission'] }
);

const persistConfig = {
  key: 'root',
  storage,
  whiteList: ['accessToken', 'refreshToken', 'onlineStatus', 'userInfo'],
  transforms: [excludeSubmissionState],
};
const persistedReducer = persistReducer(persistConfig, reducer);

/** Redux store */
const store = createStore(
  persistedReducer,
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
);

/** Redux store  */
export default store;

/** Redux Storage peristor */
export const persistor = persistStore(store);
